








































import Vue from 'vue'
import Component from 'vue-class-component'
import FormTextField from '@/components/FormTextField.vue'
import { Prop } from 'vue-property-decorator'
import * as api from '@/services/ApiService'
import appManager from '@/services/AppManager'
import { extractResponseErrorMessage } from '@/services/ApiService'
import { isBlank } from '@/core/Utils'
import { convertDateLocalToUtc, convertDateUtcToLocal, daysToMillis, MILLIS_PER_DAY } from '@/core/DateUtils'
import { isAlphaNumeric } from '@/core/StringUtils'
import FormDateTimeField from '@/components/FormDateTimeField.vue'

@Component({
    components: {
        FormTextField,
        FormDateTimeField
    }
})
export default class CreateAccessCodeDialog extends Vue {
    @Prop()
    value: boolean|undefined // true to show the dialog
    @Prop()
    initialAccessCodeId: string|undefined
    @Prop()
    onCloseRequested: (() => void)|undefined
    name: string|null = null
    nameErrorMessage: string|null = null
    accessEndMillis: number = 0
    accessCodeId: string|null = null
    accessCodeIdErrorMessage: string|null = null
    formErrorMessage: string|null = null
    isCreating: boolean = false

    created() {
        const nowUtc = Date.now()
        const nowLocal = convertDateUtcToLocal(new Date(nowUtc)).getTime()
        const startOfTodayLocal = nowLocal - (nowLocal % MILLIS_PER_DAY)
        const accessEndLocal = startOfTodayLocal + daysToMillis(8)
        this.accessEndMillis = convertDateLocalToUtc(new Date(accessEndLocal)).getTime()
        this.accessCodeId = this.initialAccessCodeId || null
    }

    onCancelPressed() {
        if (this.onCloseRequested)
            this.onCloseRequested()
    }

    async onCreatePressed(): Promise<void> {
        this.validatePage()
        if (this.formErrorMessage)
            return

        this.isCreating = true

        try {
            await api.createAccessCode({
                name: this.name!,
                accessEndMillis: this.accessEndMillis!,
                accessCodeId: this.accessCodeId!,
            })

            this.formErrorMessage = null

            if (this.onCloseRequested)
                this.onCloseRequested()

            appManager.alertManager.publishSuccess('Access Code successfully added')
        } catch (error) {
            this.formErrorMessage = extractResponseErrorMessage(error) || 'Error creating access code. Please try again later.'
        }

        // go ahead and log in
        this.isCreating = false
    }

    validatePage() {
        this.nameErrorMessage = isBlank(this.name) ? 'Specify a name' : null
        this.accessCodeIdErrorMessage = (!this.accessCodeId || !isAlphaNumeric(this.accessCodeId)) ? 'Specify an access code of letters and numbers' : null

        const hasError = !!this.nameErrorMessage ||
            !!this.accessCodeIdErrorMessage
        this.formErrorMessage = hasError ? 'Please correct the error above' : null
    }
}
